module.exports = "<div class=\"left-sidebar\">\n  <app-sidebarmenu current_state = \"dashboard\"></app-sidebarmenu>\n</div>\n<div class=\"right-content\">\n  <app-app-header current_state=\"dashboard\"></app-app-header>\n  <app-welcome-profile></app-welcome-profile>\n  <app-home></app-home>\n  <app-dashboard-notifications></app-dashboard-notifications>\n  <app-copy-right></app-copy-right>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/components/dashboard/dashboard.component.html
// module chunks = main